import React, { useState, useEffect, createContext } from "react";

const AuthContext = createContext();
const { Provider } = AuthContext;

const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function checkIfUserIsLoggedIn() {
			try {
				let response = await fetch("/api/auth/login");

				if (!response.ok) {
					throw new Error("Unauthenticated");
				}
				let fetchedUser = await response.json();
				setUser(fetchedUser);
			} catch (error) {
				setUser(false);
			} finally {
				setLoading(false);
			}
		}

		checkIfUserIsLoggedIn();

		return () => {
			// clean up function
		};
	}, [user]);

	const authenticate = async (email, password) => {
		let response = await fetch("/api/auth/login", {
			method: "POST",
			body: JSON.stringify({ email, password }),
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (!response.ok) {
			throw new Error("Login Failed");
		}

		let loggedInUser = await response.json();
		setUser(loggedInUser);

		return loggedInUser;
	};

	const signout = async () => {
		let response = await fetch("/api/auth/logout", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		});
		if (!response.ok) {
			throw new Error("Logout Failed");
		}

		let body = await response.json();
		setUser(false);

		return body;
	};

	return (
		<Provider
			value={{
				authenticate,
				signout,
				isAuthenticated: user ? true : false,
				user,
				loading,
			}}
		>
			{children}
		</Provider>
	);
};

// Create our own hook for accessing the context from any functional component
function useAuth() {
	return React.useContext(AuthContext);
}

export { useAuth, AuthProvider };
